<template>
    <div class="base-mit-menu-header">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-h6">
                {{userModel.fname}} {{userModel.lname}}
              </v-list-item-title>
              <v-list-item-subtitle>{{userModel.email}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </div>
</template>

<script>

export default {
  name: 'BaseMitMenuHeader',
  components: {
  },
  props: {
    userModel: Object
  }
}
</script>

<style lang="scss" scoped>
</style>
